export const handleRequestError = async (response: Response) => {
  try {
    const data = await response.json();
    console.error(`${response.status} ${response.statusText}:`, data);
  } catch (e) {
    const data = await response.text();
    console.error(`${response.status} ${response.statusText}: ${data}`);
  }
};
